import { Fragment } from "react";
import { isEmpty } from "lodash";
import { t } from "@/i18n-js/instance";
import type { Participant as ParticipantType } from "@/react/types/Live/Participant";
import { GroupHeader } from "@circle-react/components/LiveStreams/Room/Sidebar/Participants/GroupHeader";
import { Loader } from "@circle-react-uikit/Loader";
import { useGuests, useParticipants } from "../../hooks";
import { Participant } from "./Participant";
import { useGroupParticipants } from "./hooks";

export const Participants = () => {
  const { activeParticipants, isLoading } = useParticipants();
  const { host, participantsGroup } = useGroupParticipants({
    activeParticipants,
  });
  const { guests } = useGuests();

  const participantGroups = [
    {
      group: participantsGroup.moderators,
      title: t("live_roles.moderators"),
    },
    {
      group: participantsGroup.cohosts,
      title: t("live_roles.cohosts"),
    },
    {
      group: participantsGroup.participants,
      title: t("live_roles.participants"),
    },
    {
      group: guests,
      title: t("live_roles.guests"),
    },
  ];

  if (isLoading) {
    return <Loader center />;
  }
  return (
    <div className="mt-2 flex grow flex-col items-stretch justify-start overflow-auto">
      {participantGroups.map(({ group, title }) => {
        if (isEmpty(group)) return null;
        return (
          <Fragment key={`participant-group-${title}`}>
            <GroupHeader title={title} />
            {group.map((participant: ParticipantType) => (
              <Participant
                key={`participant-${title}-${participant.id}`}
                participant={participant}
                host={host}
              />
            ))}
          </Fragment>
        );
      })}
    </div>
  );
};
